var _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 600,
    fill: "#032EA1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 300,
    y: 150,
    fill: "#E00025"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 360,
    width: 180,
    height: 34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435,
    y: 235,
    width: 30,
    height: 130
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405,
    y: 270,
    width: 24,
    height: 95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471,
    y: 270,
    width: 24,
    height: 95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 300,
    width: 18,
    height: 65
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 300,
    width: 18,
    height: 65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450 205l22 40h-44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417 250l16 26h-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 250l16 26h-32z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKh);
export default __webpack_public_path__ + "static/media/kh.94eb6a0212e605f95978e4fc5163938d.svg";
export { ForwardRef as ReactComponent };